import type { Cluster, SearchFilters } from "@little-finds/core";

/** Use the same 12°/4° grouping cells as search_locations and the reference matcher. */
export function clusterSearchFilters(
  filters: SearchFilters,
  cluster: Cluster,
): SearchFilters {
  const size = (filters.zoom ?? 10) < 4 ? 12 : 4;
  const south = Math.floor(cluster.latitude / size) * size;
  const west = Math.floor(cluster.longitude / size) * size;
  return {
    ...filters,
    center: { latitude: cluster.latitude, longitude: cluster.longitude },
    bounds: {
      south: Math.max(-90, south),
      north: Math.min(90, south + size),
      west: Math.max(-180, west),
      east: Math.min(180, west + size),
    },
    scope: "us",
    zoom: 6,
    offset: 0,
  };
}

export function clusterCoordinates(cluster: Cluster): string {
  return `${Math.abs(cluster.latitude).toFixed(1)}° ${cluster.latitude < 0 ? "S" : "N"}, ${Math.abs(cluster.longitude).toFixed(1)}° ${cluster.longitude < 0 ? "W" : "E"}`;
}
